<template>
  <v-row>
    <v-col cols="12 py-0 pt-2 px-8">
      <h3>Thông tin SKU</h3>
    </v-col>
    <v-col cols="12" class="py-0 pt-4">
      <v-row>
        <v-col cols="6" class="py-0 px-8">
          <div class="d-flex">
            <v-btn
              class="btn-info"
              small
              @click="showCreateForm"
            >
              + Thêm SKU
            </v-btn>

            <v-btn
              class="btn-save mx-0"
              small
              @click="handleEditAll"
            >
              Chỉnh sửa hàng loạt
            </v-btn>
            <v-btn
              class="btn-save-all mx-3"
              small
              v-if="checkShowSaveAll()"
              @click="handleSaveAll"
            >
              Lưu hàng loạt
            </v-btn>
          </div>
        </v-col>
        <v-col cols="6" class="py-0 px-8 justify-end d-flex">
          <v-row>
            <v-col offset="6" cols="6" class="py-0">
              <v-text-field
                class="text-search"
                outlined
                dense
                placeholder="Nhập tên SKU"
                @keyup="searchSkuOffline"
                v-model="txtSkuName"
              >
                <v-icon
                  class="icon-search"
                  slot="prepend"
                  color="#adadad"
                >
                  mdi-magnify
                </v-icon>
              </v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-col class="py-0 px-8 pb-3 table-product" cols="12">
        <v-simple-table class="table-layout table-custom table-sku">
          <thead>
            <tr>
              <th class="col-code">Mã SKU</th>
              <th class="col-name">Tên SKU*</th>
              <th class="col-name-card">Tên trên thẻ học*</th>
              <th class="col-name-card">Mã Combo LMS*</th>
              <th class="col-price">Giá</th>
              <th class="col-subject">Môn*</th>
              <th class="col-curriculum">Chương trình*</th>
              <th class="col-program-group">Lộ trình*</th>
              <th class="col-level">Trình độ</th>
              <th class="col-class-type">Loại lớp*</th>
              <th class="col-teacher-type">Giáo viên*</th>
              <th class="col-num-lesson text-center">Số buổi*</th>
              <th class="col-expire-date">Hạn sử dụng</th>
              <th class="col-status">Trạng thái*</th>
              <th class="col-transaction">Giao dịch*</th>
              <th class="col-action text-center">Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!skuItems.length">
              <td colspan="13">Không có dữ liệu</td>
            </tr>
            <template v-if="skuItems.length">
             <validation-observer ref="validator" v-for="(item, index) in skuItems" tag="tr" :key="index" @dblclick="handleEditRow(item)">
                <td :class="[ item.isEdit ? 'edit-data': '']">
                    {{ item.code || '__' }}
                </td>
                <td :class="[ item.isEdit ? 'mt-6': '' ]">
                    <template v-if="item.isEdit">
                        <validation-provider v-slot="{ errors }" :rules="{ required: true}" name="Tên SKU" :vid="`name + ${index}`">
                            <v-text-field
                                    class="text-field"
                                    :error-messages="errors"
                                    outlined
                                    dense
                                    maxLength="100"
                                    placeholder="Nhập tên SKU"
                                    v-model="item.name"
                            >
                            </v-text-field>
                        </validation-provider>
                    </template>
                    <span v-else>{{ item.name }}</span>
                </td>
                <td :class="[ item.isEdit ? 'mt-6': '' ]">
                    <template v-if="item.isEdit">
                        <validation-provider v-slot="{ errors }" :rules="{ required: true }" name="Tên trên thẻ học" :vid="`name-card + ${index}`">
                            <v-text-field
                                    class="text-field"
                                    :error-messages="errors"
                                    outlined
                                    dense
                                    maxLength="50"
                                    placeholder="Tên trên thẻ học"
                                    v-model="item.cardDisplayName"
                            >
                            </v-text-field>
                        </validation-provider>
                    </template>
                    <span v-else>{{ item.cardDisplayName }}</span>
                </td>
                <td :class="[ item.isEdit ? 'mt-6': '' ]">
                    <template v-if="item.isEdit">
                      <validation-provider v-slot="{ errors }" :rules="{ required: true }" name="Mã Combo LMS" :vid="`lmsCodes + ${index}`">
                        <v-autocomplete
                          class="text-field"
                          :error-messages="errors"
                          :clearable="true"
                          :items="lmsCodes"
                          item-value="code"
                          item-text="code"
                          :aLight="'right'"
                          placeholder="Chọn"
                          attach
                          outlined
                          dense
                          multiple
                          v-model="item.lmsCodes"
                          :menu-props="{ bottom: true, offsetY: true, maxHeight: '200' }"
                        />
                      </validation-provider>
                    </template>
                    <span v-else>{{ item.lmsCodes.join(', ') }}</span>
                </td>
                <td>
                    <template v-if="item.isEdit">
                        <validation-provider v-slot="{ errors }" :rules="{ required: true, max: 10}" name="Giá"  :vid="`orgPrice + ${index}`">
                            <v-text-field
                                    class="text-field text-field-number"
                                    :error-messages="errors"
                                    outlined
                                    dense
                                    placeholder="Nhập giá"
                                    type="number"
                                    min="0"
                                    @input="item.orgPrice= item.orgPrice.replace(/[^0-9\.]/g,'');"
                                    v-model="item.orgPrice"
                            >
                            </v-text-field>
                        </validation-provider>
                    </template>
                    <span v-else>{{  item.orgPrice ? formatPrice(item.orgPrice)+' đ' : '0 đ' }}</span>
                </td>
                <td>
                    <template v-if="item.isEdit">
                        <validation-provider v-slot="{ errors }" :rules="{ required: true}" name="Môn" :vid="`subjectId + ${index}`">
                            <v-autocomplete
                                    class="text-field"
                                    :error-messages="errors"
                                    :clearable="true"
                                    :items="subjects"
                                    item-value="id"
                                    item-text="name"
                                    :aLight="'right'"
                                    placeholder="Chọn"
                                    attach
                                    outlined
                                    dense
                                    :disabled="item.id ? true : false"
                                    @change="changeSubject(item)"
                                    v-model="item.subjectId"
                                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '200' }"
                            />
                        </validation-provider>
                    </template>
                    <span v-else> {{ subjectsObj[item.subjectId] }}</span>
                </td>
                <td>
                    <template v-if="item.isEdit">
                        <validation-provider v-slot="{ errors }" :rules="{ required: true}" name="Chương trình" :vid="`curriculumId + ${index}`">
                          <v-autocomplete
                                  class="text-field"
                                  :clearable="true"
                                  :error-messages="errors"
                                  :items="getCurriculums(item)"
                                  item-value="id"
                                  item-text="title"
                                  :aLight="'right'"
                                  placeholder="Chọn"
                                  attach
                                  outlined
                                  dense
                                  @change="changeCurriculum(item)"
                                  v-model="item.curriculumId"
                                  :menu-props="{ bottom: true, offsetY: true, maxHeight: '200' }"
                          ></v-autocomplete>
                        </validation-provider>
                    </template>
                    <span v-else> {{ curriculumsObj[item.curriculumId] ? curriculumsObj[item.curriculumId].title : '__' }}</span>
                </td>
                <td>
                    <template v-if="item.isEdit">
                        <validation-provider v-slot="{ errors }" :rules="{ required: true}" name="Lộ trình" :vid="`learningPathIds + ${index}`">
                            <v-autocomplete
                                    class="text-field"
                                    :error-messages="errors"
                                    :clearable="true"
                                    :items="getLearningPaths(item)"
                                    item-value="id"
                                    item-text="title"
                                    :aLight="'right'"
                                    placeholder="Chọn"
                                    attach
                                    outlined
                                    dense
                                    multiple
                                    v-model="item.learningPathIds"
                                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '200' }"
                            ></v-autocomplete>
                        </validation-provider>
                    </template>
                    <span v-else>
                     {{ curriculumsObj[item.curriculumId] ?
                        (showLearningPath(curriculumsObj[item.curriculumId], item.learningPathIds) ? showProgramGroups(showLearningPath(curriculumsObj[item.curriculumId], item.learningPathIds)) : '' )
                        : '__'
                        }}
                    </span>
                </td>
                <td>
                    <template v-if="item.isEdit">
                        <v-select
                                class="text-field"
                                :clearable="true"
                                :items="curriculumTypes"
                                item-value="id"
                                item-text="name"
                                :aLight="'right'"
                                placeholder="Chọn"
                                attach
                                outlined
                                dense
                                v-model="item.level"
                                :menu-props="{ bottom: true, offsetY: true, maxHeight: '200' }"
                        ></v-select>
                    </template>
                    <span v-else>
                     {{ item.level ? curriculumTypesObj[item.level] : '--' }}
                    </span>
                </td>
                <td>
                    <template v-if="item.isEdit">
                        <validation-provider v-slot="{ errors }" :rules="{ required: true}" name="Loại lớp" :vid="`classTypeId + ${index}`">
                            <v-autocomplete
                                    class="text-field"
                                    :error-messages="errors"
                                    :clearable="true"
                                    :items="classTypes"
                                    item-value="id"
                                    item-text="name"
                                    :aLight="'right'"
                                    placeholder="Chọn"
                                    attach
                                    outlined
                                    dense
                                    v-model="item.classTypeId"
                                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '200' }"
                            ></v-autocomplete>
                        </validation-provider>
                    </template>
                    <span v-else>
                      {{ classTypesObj[item.classTypeId] }}
                    </span>
                </td>
                <td>
                    <template v-if="item.isEdit">
                        <validation-provider v-slot="{ errors }" :rules="{ required: true}" name="Giáo viên" :vid="`teacherTypeId + ${index}`">
                            <v-select
                                    class="text-field"
                                    :error-messages="errors"
                                    :clearable="true"
                                    :items="teacherTypes"
                                    item-value="id"
                                    item-text="name"
                                    :aLight="'right'"
                                    placeholder="Chọn"
                                    attach
                                    outlined
                                    dense
                                    v-model="item.teacherTypeId"
                                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '200' }"
                            ></v-select>
                        </validation-provider>
                    </template>
                    <span v-else>
                      {{ teacherTypesObj[item.teacherTypeId] }}
                    </span>
                </td>
                <td class="text-center">
                    <template v-if="item.isEdit">
                        <validation-provider v-slot="{ errors }" :rules="{ required: true, max: 10}" name="Số buổi" :vid="`numOfLesson + ${index}`">
                            <v-text-field
                                    class="text-field text-field-number"
                                    :error-messages="errors"
                                    outlined
                                    dense
                                    placeholder="Nhập số"
                                    type="number"
                                    min="0"
                                    @input="item.numOfLesson= item.numOfLesson.replace(/[^0-9\.]/g,'');"
                                    v-model="item.numOfLesson"
                            >
                            </v-text-field>
                        </validation-provider>
                    </template>
                    <span v-else>
                      {{ item.numOfLesson }}
                    </span>
                </td>
                <td>
                  <template v-if="item.isEdit">
                    <v-text-field
                        class="text-field text-field-number"
                        outlined
                        dense
                        placeholder="Nhập số tháng"
                        type="number"
                        min="1"
                        @input="item.monthsValid= item.monthsValid.replace(/[^0-9\.]/g,'');"
                        v-model="item.monthsValid"
                    >
                    </v-text-field>
                  </template>
                  <span v-else>
                      {{ item.monthsValid }}
                    </span>
                </td>
                <td>
                    <template v-if="item.isEdit">
                        <validation-provider v-slot="{ errors }" :rules="{ required: true}" name="Trạng thái" :vid="`status + ${index}`">
                            <v-select
                                    class="text-field"
                                    :error-messages="errors"
                                    :clearable="true"
                                    :items="skuStatus"
                                    item-value="id"
                                    item-text="name"
                                    :aLight="'right'"
                                    placeholder="Chọn"
                                    attach
                                    outlined
                                    dense
                                    v-model="item.status"
                                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '200' }"
                            ></v-select>
                        </validation-provider>
                    </template>
                    <span v-else>
                    {{ skuStatusObj[item.status] }}
                    </span>
                </td>
                <td>
                    <template v-if="item.isEdit">
                        <validation-provider v-slot="{ errors }" :rules="{ required: true}" name="Giao dịch" :vid="`transactionStatus + ${index}`">
                            <v-select
                                    class="text-field"
                                    :error-messages="errors"
                                    :clearable="true"
                                    :items="skuTransaction"
                                    item-value="id"
                                    item-text="name"
                                    :aLight="'right'"
                                    placeholder="Chọn"
                                    attach
                                    outlined
                                    dense
                                    v-model="item.transactionStatus"
                                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '200' }"
                            ></v-select>
                        </validation-provider>
                    </template>
                    <span v-else>
                     {{ skuTransactionObj[item.transactionStatus] }}
                    </span>
                </td>
              <td :class="[ item.isEdit ? 'edit-data': '', 'text-center' ]">
                  <div class="d-flex align-center justify-center">
                      <div v-show="item.isEdit && !item.id && !productId">
                          <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                  <v-icon @click="handleSubmitData(item, index)" class="cursor-pointer"  color="#002E86" v-on="on">
                                      mdi-content-save
                                  </v-icon>
                              </template>
                              <span>Save draft</span>
                          </v-tooltip>
                      </div>
                      <div v-show="item.isEdit && productId">
                          <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                  <v-icon @click="handleSubmitData(item, index)" class="cursor-pointer"  color="#329D20" v-on="on">
                                      mdi-check-circle
                                  </v-icon>
                              </template>
                              <span> {{ item.id  ? 'Update' : 'Create'}}</span>
                          </v-tooltip>
                      </div>
                      <div v-show="productId" >
                          <v-tooltip v-if="productId" bottom>
                              <template v-slot:activator="{ on }">
                                  <v-icon v-on="on" @click="cloneSKU(item)" class="ml-3 cursor-pointer" color="#4048FF">
                                      mdi-plus-circle-outline
                                  </v-icon>
                              </template>
                              <span>Clone SKU</span>
                          </v-tooltip>
                      </div>
                      <div v-show="!item.id" >
                          <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                  <v-icon v-on="on" class="ml-3 cursor-pointer" color="#959595" @click="deleteSku(item, index)">
                                      mdi-delete
                                  </v-icon>
                              </template>
                              <span>Xóa SKU</span>
                          </v-tooltip>
                      </div>
                      <v-tooltip bottom v-if="item.id">
                          <template v-slot:activator="{ on }">
                            <a :href="`${detailSkuLink(item, index)}`" rel="noopener noreferrer" @click.prevent>
                              <v-icon v-on="on" class="ml-3 cursor-pointer" color="#959595" @click="detailSku(item, index)">
                                  mdi-sale
                              </v-icon>
                            </a>
                          </template>
                          <span>Chính sách</span>
                      </v-tooltip>
                  </div>
                </td>
             </validation-observer>
            </template>
            <tr v-if="skuItems.length < 4" class="tr-no-data"><td colspan="13"></td></tr>
          </tbody>
        </v-simple-table>
    </v-col>
  </v-row>
</template>

<script>
import RepositoryFactory from '@/repositories/RepositoryFactory';
const ProductRepository = RepositoryFactory.get('product');
const OrderRepository = RepositoryFactory.get('order');

import SkuTutor from '../../models/SkuTutor';
import SkuDuo from "@/pages/product-management/models/SkuDuo";
import {formatDate} from "@/helpers/utils";
import Login from "@/pages/Login.vue";

export default {
  name: 'tutor-sku-list',
  components: {
  },
  props:{
    skuItems: {
      type: Array,
      default: () => [],
    },
    productAttributes: {
      type: Object,
      default: () => {},
    },
    productId: {
      type: Number,
      default: () => null,
    },
    curriculumsObj: {
      type: Object,
      default: () => {},
    },
    curriculums: {
      type: Array,
      default: () => {},
    },
    isUpdateDone: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      tab: 0,
      isShowSku: false,
      newSku: new SkuTutor({}),
      subjects: [],
      curriculumTypes: [],
      grades: [],
      skuActivation: [],
      durationType: [],
      skuStatus: [],
      skuTransaction: [],
      learningPaths: [],
      classTypes: [],
      teacherTypes: [],
      subjectsObj: {},
      curriculumTypesObj: {},
      skuStatusObj: {},
      skuTransactionObj: {},
      classTypesObj: {},
      teacherTypesObj: {},
      learningPathsObj: {},
      txtSkuName: null,
      listProduct: [],
      lmsCodes: [],
      isEditAll: false,
      skuItemsClone: [],
    };
  },
  computed: {
  },
   async created() {
    this.subjects = this.productAttributes.subjects;
    this.productAttributes.subjects.forEach((item) => {
      this.subjectsObj[item.id] = item.name;
    });

    this.curriculumTypes = this.productAttributes.skuTutorLevel;
    this.productAttributes.skuTutorLevel.forEach((item) => {
      this.curriculumTypesObj[item.id || item.code] = item.name;
    });

    // this.grades = this.productAttributes.grades;
    // this.skuActivation = this.productAttributes.skuActivation;
    // this.durationType = this.productAttributes.durationType;
    this.skuStatus = this.productAttributes.skuStatus;
    this.productAttributes.skuStatus.forEach((item) => {
      this.skuStatusObj[item.id || item.code] = item.name;
    });

    this.skuTransaction = this.productAttributes.skuTransaction;
    this.productAttributes.skuTransaction.forEach((item) => {
      this.skuTransactionObj[item.id || item.code] = item.name;
    });

    this.classTypes = this.productAttributes.classTypes;
    this.classTypes = this.productAttributes.classTypes;
    this.productAttributes.classTypes.forEach((item) => {
      this.classTypesObj[item.id || item.code] = item.name;
    });

    this.teacherTypes = this.productAttributes.teacherTypes;
    this.productAttributes.teacherTypes.forEach((item) => {
      this.teacherTypesObj[item.id || item.code] = item.name;
    });
    this.getLmsCodes();
  },
  beforeDestroy() {
  },
  watch: {
    isUpdateDone(val) {
        if (val) {
            this.skuItemsClone = _.cloneDeep(this.skuItems)
            this.isUpdateDone = false
        }
    }
  },
  methods: {
      changeSubject(item) {
          item.curriculumId= ''
          item.learningPathIds=  ''
      },
      changeCurriculum(item) {
          item.learningPathIds= ''
      },
      handleEditRow(item) {
          this.skuItemsClone = _.cloneDeep(this.skuItems)
          this.$emit('onEditRow', item)
      },
      getCurriculums(item) {
          if (item.subjectId) {
              return this.curriculums.filter(data => data.subject_id === item.subjectId)
          }
          return []
      },
      getLearningPaths(item) {
          if (item.curriculumId) {
              const curriculum = this.curriculums.find((data) => data.id === item.curriculumId);
              if (curriculum && curriculum.program_groups) {
                  return curriculum.program_groups;
              }
              return []
          }
          return []
      },
      async handleSubmitData(item, index) {
          const valid =await this.$refs.validator[index].validate()
          if (!valid) {
              return
          } else {
              if(this.productId) {
                const changeData = this.skuItemsClone.find(data => data.id === item.id)
                if (changeData && changeData.orgPrice !== Number(item.orgPrice)) {
                    this.$swal({
                        title: "Khi cập nhật lại giá cần thực hiện cài đặt lại chính sách giá. Bạn có chắc chắn muốn thực hiện thay đổi?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Xác nhận",
                        cancelButtonText: "Hủy",
                    }).then(async (result) => {
                        if (result.value) {
                            const data = this.makeData(item)
                            delete data.data.skuItem.id
                            this.$emit('onUpdateRow', item, {
                                skuId: item.id,
                                ...data
                            })
                        }
                    });
                } else {
                  const data = this.makeData(item)
                  delete data.data.skuItem.id
                  this.$emit('onUpdateRow', item, {
                      skuId: item.id,
                      ...data
                  })
                }
                if (!item.id) {
                  const data = this.makeData(item)
                  delete data.data.skuItem.id
                  this.$emit('onCreateRow', data)
                }
              }else {
                  item.isEdit= false
              }
          }
      },
      async handleSubmitDataEditAll(item, index) {
          const valid = await this.$refs.validator[index].validate()
          if (!valid) {
              return
          } else {
              if (this.productId) {
                if (!item.id) {
                  const data = this.makeData(item)
                  this.$emit('onCreateRow', data)
                } else {
                  const data = this.makeData(item)
                  delete data.data.skuItem.id
                  this.$emit('onUpdateRow', item, {
                      skuId: item.id,
                      ...data
                  })
                }
              } else {
                item.isEdit= false
              }
          }
      },
      makeData(item) {
          const skuItem= new SkuTutor(item)
          return {
              data: {
                  skuItem: {
                      ...skuItem,
                      name: item.name.trim(),
                      code: item.code,
                  }
              }
          }
      },
      cloneSKU(item) {
          this.$emit('onCloneSKU', item)
      },
      handleEditAll() {
          this.isEditAll = !this.isEditAll
          if(this.isEditAll) {
              this.skuItems.forEach(item => item.isEdit = true)
              this.skuItemsClone = _.cloneDeep(this.skuItems)
              
          }else {
              this.skuItems.forEach(item => item.isEdit = false)
          }
      },
      async handleSaveAll() {
        let haveEditPrice = await this.skuItemsClone.some((item) => {
          let data = this.skuItems.find((data) => data.id === item.id)
          return data && Number(data.orgPrice) !== item.orgPrice
        })
        if (haveEditPrice) {
          this.$swal({
            title: "Khi cập nhật lại giá cần thực hiện cài đặt lại chính sách giá. Bạn có chắc chắn muốn thực hiện thay đổi?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Xác nhận",
            cancelButtonText: "Hủy",
          }).then(async (result) => {
              if (result.value) {
                await this.skuItems.forEach((item, index) => {
                    if (item.isEdit) {
                      this.handleSubmitDataEditAll(item, index)
                    }
                })
              } else {
                this.skuItems.forEach((item, index) => {
                  let changeData = this.skuItemsClone.find((data) => data.id === item.id)
                  if (changeData && changeData.orgPrice === Number(item.orgPrice)){
                    this.handleSubmitDataEditAll(item, index)
                  }
                })
              }
          });
        } else {
          await this.skuItems.forEach((item, index) => {
            if (item.isEdit) {
              this.handleSubmitDataEditAll(item, index)
            }
          })
        }
      },
      searchSkuOffline: _.debounce(function (item, index, type = null) {
          this.$emit('searchSkuOffline', this.txtSkuName.trim());
      }, 500),
      showCreateForm() {
          this.$emit('onCreateSKU')
      },
      showLearningPath(curriculum, programGroups) {
          let dataProgramGroups = [];
          if (curriculum.program_groups.length) {
              curriculum.program_groups.forEach((pg) => {
                  programGroups.forEach(item => {
                      if (item === pg.id) {
                          dataProgramGroups.push(pg.title);
                      }
                  })
              });
          }
          return dataProgramGroups
      },
      showProgramGroups(data) {
          let title = ''
          if (data.length) {
              data.forEach((item, index) => {
                  title += data.length - 1 > index ? item + ', ' : item
              })
          }
          return title
      },
      deleteSku(item, index) {
          if (!item.id) {
              this.$swal
                  .fire({
                      title: "Bạn muốn đóng form? Tất cả thông tin sẽ bị mất!",
                      icon: "warning",
                      showCancelButton: true,
                      cancelButtonText: "Hủy",
                      confirmButtonColor: "#3085d6",
                      cancelButtonColor: "#d33",
                      confirmButtonText: "Đồng ý",
                  })
                  .then(async (result) => {
                      if (result?.value) {
                          this.skuItems.splice(index, 1);
                      }
                  });
          }
      },
      detailSku(item) {
          this.$router.push({
              path: `/products/${this.productId}/sku/${item.id}`,
              query: {
                    sku_type: 'tutor',
              },
          });
      },
      detailSkuLink(item) {
        return `/products/${this.productId}/sku/${item.id}?sku_type=tutor`;
      },
      async getLmsCodes() {
        const res = await OrderRepository.getListLmsCodes();
        if (res && res.data) {
          this.lmsCodes = res.data;
        }
      },
      checkShowSaveAll() {
          const data = _.cloneDeep(this.skuItems)
          if (data.filter(item => item.isEdit).length > 1) {
              return true
          }
          return false
      },
  },
  watch: {
  }
};
</script>
<style scoped lang="scss">
  .btn-save {
    background: #8465FF !important;
    color: #fff;
  }
  .btn-cancel  {
    background: #787878 !important;
    color: #fff;
  }

  .btn-info {
    background: #6587FF !important;
    color: #fff;
  }

  .icon-search {
    left: 40px;
    position: relative;
  }
  .table-custom {
    th {
      background: #E7E8FF;
      border-left: 1px solid #fff;
    }
  }

  .col-code {
    max-width: 150px;
    min-width: 150px;
  }
  .col-name {
    max-width: 300px;
    min-width: 300px;
  }

  .col-name-card {
    max-width: 300px;
    min-width: 300px;
  }

  .col-price {
    max-width: 150px;
    min-width: 150px;
  }
  .col-subject {
    max-width: 250px !important;
    min-width: 250px !important;
  }
  .col-curriculum {
    max-width: 300px;
    min-width: 300px;
  }
  .col-program-group {
    max-width: 400px;
    min-width: 400px;
  }
  .col-level {
    max-width: 180px;
    min-width: 180px;
  }
  .col-class-type {
    max-width: 180px;
    min-width: 180px;
  }
  .col-teacher-type {
    max-width: 180px;
    min-width: 180px;
  }
  .col-num-lesson {
    max-width: 150px;
    min-width: 150px;
  }
  .col-status {
    max-width: 240px;
    min-width: 240px;
  }
  .col-transaction {
    max-width: 180px;
    min-width: 180px;
  }
  .col-action {
    max-width: 150px;
    min-width: 150px;
  }
  .col-expire-date {
    max-width: 150px;
    min-width: 150px;
  }
</style>

<style lang="scss">
  .text-field fieldset {
    background: #fff !important;
  }
  .text-search {
    .v-input__slot {
      min-height: 20px !important;
      padding-left: 35px !important;
    }
  }
  .edit-data {
    vertical-align: top;
    padding-top: 24px !important;
  }
  .btn-save-all {
    background: #FF5500 !important;
  }

</style>
